import { RcFile } from 'antd/es/upload';

export const replaceNonuniqFolder = (file: RcFile, thisDirFolderNames: string[]) => {
  if (file.webkitRelativePath.split('/').length > 1) {
    const folderName = file.webkitRelativePath.split('/')[0];
    if (thisDirFolderNames.includes(folderName)) {
      const newFile = new File([file], file.name, {type: file.type});   
      Object.defineProperty(newFile, 'webkitRelativePath', {
        value: file.webkitRelativePath.replace(folderName, `${folderName}(1)`),
      });
      return newFile as RcFile;
    };
    return file;
  };
  return file;
};

export const createFilePath = (filePath: string[], thisDirFolderNames: string[]) => {
  if (filePath.length > 1 ) {
    if (thisDirFolderNames.includes(filePath[0])) {
      return filePath.join('/').replace(filePath[0], `${filePath[0]}(1)`)
    } else {
      return filePath.join('/');
    }
  }
  return '';
}
